module.exports = __webpack_public_path__ + "static-portal/img/map-lh.c83eb43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map-lh.png
// module id = 3823
// module chunks = 4